import { LANDING_VERSION } from '../version'
import NoxLogoSvg from '@/assets/images/nox-logo.svg'

// NOX 版本執行時期的全域 branding 覆寫（title / favicon / Google Font）
// 只在 LANDING_VERSION === 'nox' 時套用

const NOX_TITLE = 'NOX — Trading data, turned into earnings'

// favicon 指向打包後的 nox bull logo SVG（與 header logo 一致）
const NOX_FAVICON_URL = NoxLogoSvg

const FONTS_ID = 'nox-google-fonts'
const FONTS_HREF = 'https://fonts.googleapis.com/css2?family=IBM+Plex+Sans:wght@400;500;600;700&display=swap'

const loadNoxFonts = () => {
  if (document.getElementById(FONTS_ID)) return

  const preconnectGoogle = document.createElement('link')
  preconnectGoogle.rel = 'preconnect'
  preconnectGoogle.href = 'https://fonts.googleapis.com'
  preconnectGoogle.id = `${FONTS_ID}-pc1`

  const preconnectStatic = document.createElement('link')
  preconnectStatic.rel = 'preconnect'
  preconnectStatic.href = 'https://fonts.gstatic.com'
  preconnectStatic.crossOrigin = 'anonymous'
  preconnectStatic.id = `${FONTS_ID}-pc2`

  const link = document.createElement('link')
  link.rel = 'stylesheet'
  link.href = FONTS_HREF
  link.id = FONTS_ID

  document.head.appendChild(preconnectGoogle)
  document.head.appendChild(preconnectStatic)
  document.head.appendChild(link)
}

export const applyNoxBranding = () => {
  if (LANDING_VERSION !== 'nox') return

  document.title = NOX_TITLE

  const favicon = document.getElementById('favicon') as HTMLLinkElement | null
  if (favicon) favicon.href = NOX_FAVICON_URL

  loadNoxFonts()
}
